<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import type { MaterialSymbolName } from '@shared/types/materialSymbolNames';
import type { ButtonVariant, ButtonSize } from './BaseButton.vue';

const props = withDefaults(
  defineProps<{
    icon: MaterialSymbolName;
    alt: string;
    // Shown in place of the alt text, e.g. to explain why the button is disabled.
    tooltip?: string;
    shortcutIcon?: MaterialSymbolName;
    type?: 'submit' | 'button';
    size?: ButtonSize;
    variant?: ButtonVariant;
    destructive?: boolean;
    active?: boolean;
    loading?: boolean;
    disabled?: boolean;
    route?: RouteLocationRaw;
    class?: HTMLAttributes['class'];
  }>(),
  {
    type: 'button',
    // This is a different default variant to the BaseButton component: largely
    // for legacy reasons, but also because it is far more common
    variant: 'text',
  },
);
</script>

<template>
  <BaseTooltip :text="tooltip ?? alt" :shortcut-icon as-child>
    <BaseButton
      :type
      :size
      :variant
      :destructive
      :active
      :icon
      :loading
      :disabled
      :route
      :alt
      class="icon-button"
      :class="props.class"
    />
  </BaseTooltip>
</template>
